<template>
    <v-row>
        <v-spacer></v-spacer>
        <v-col
            v-for="item in items"
            :key="item.id"
            cols="2"
            class="d-flex flex-column"
        >
            <v-card
                class="my-12 flex d-flex flex-column"
                :elevation="renderElevation(item)"
            >
                <v-card-title>
                    <small>Carousel slot #{{ item.order }}</small>
                </v-card-title>

                <v-img
                    v-if="item.article"
                    :src="item.article.image"
                ></v-img>

                <v-card-subtitle v-if="item.article">
                    <strong>{{ item.article.title }}</strong>
                </v-card-subtitle>

                <v-card-text class="flex" v-if="perex && item.article">
                    <small>
                        {{ item.article.perex }}
                    </small>
                </v-card-text>

                <template v-if="!item.article">
                    <v-alert type="warning" class="mx-3">
                        Not used
                    </v-alert>
                </template>

                <v-divider class="mx-4"></v-divider>

                <v-card-actions
                    class="text-center"
                >
                    <v-row>
                        <v-col class="pa-2">
                            <v-btn
                                v-if="article"
                                color="success"
                                :disabled="item.article !== null"
                                plain
                                @click="useSlot(item.id)"
                                x-small
                            >
                                Apply here
                            </v-btn>
                        </v-col>
                        <v-col class="pa-2">
                            <v-btn
                                align="right"
                                color="error"
                                :disabled="!removable || item.article === null"
                                @click="emptySlot(item.article.id, item.id)"
                                plain
                                x-small
                            >
                                Remove
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>


            </v-card>
        </v-col>
        <v-spacer></v-spacer>
    </v-row>
</template>

<script>

import api from '../../_api'
import store from '../../_store'

export default {

    name: 'carousel',

    props: {
        perex: {
            type: Boolean,
            default: true
        },
        article: {
            default: null
        }
    },

    data: function () {
        return {}
    },

    computed: {
        removable: function () {
            return store.state.carouselItems.filter(i => i.article !== null).length > 3;
        },
        items() {
            return store.state.carouselItems;
        }
    },

    mounted() {
        this.loadItems()
    },

    methods: {
        loadItems: function () {
            this.$store.dispatch('loadCarouselItems');
        },

        emptySlot: function (article, slot) {
            api.emptyCarouselSlot(article).then(() => {
                this.$store.commit('emptyCarouselItems', slot)
            })
        },

        useSlot: function (slot) {
            // remove duplicity, find and unset slot with same article as we try to set for other slot

            let duplicated_slot = store.state.carouselItems.filter(i => (i.article !== null && i.article.id === this.article.id))[0]

            if(typeof(duplicated_slot) !== 'undefined')
                this.$store.commit('emptyCarouselItems',duplicated_slot.id)

            // save new slot stat to the database and update state via mutator
            api.useCarouselSlot(this.article.id, slot).then(() => {
                this.$store.commit('useCarouselItems', {
                    slot: slot,
                    article: {
                        id: this.article.id,
                        image: this.article.image_path,
                        perex: this.article.perex,
                        title: this.article.title
                    }
                })
            })
        },

        renderElevation(slot) {
            return (slot.article && this.article && slot.article.id == this.article.id) ? 10 : 1
        }
    }
}

</script>
